export default __webpack_public_path__ + "static/media/source-serif-pro-v6-latin-ext_latin-600.e5c7aa7e.woff";